import { Box, Button, Group, Modal, Paper, Stack, Text } from "@mantine/core";
import { IconDownload, IconPrinter, IconQrcode } from "@tabler/icons-react";
import { useEffect, useRef } from "react";
import { createQrCode, fetchImageAsBlobUrl } from "../utils/createQRcode";
import { printQR } from "../utils/printEventQR";

const QRCodeModal = ({ opened, close, title, description, url, logo }) => {
  const qrModalRef = useRef(null);

  useEffect(() => {
    let timer;
    let blobUrl = null;

    if (opened) {
      const generateQR = async () => {
        blobUrl = logo ? await fetchImageAsBlobUrl(logo) : null;
        if (qrModalRef.current) {
          qrModalRef.current.innerHTML = "";
          const qrCodeLarge = createQrCode(300, url, blobUrl);
          qrCodeLarge.append(qrModalRef.current);
        }
      };

      timer = setTimeout(() => {
        generateQR();
      }, 50);
    }

    return () => {
      if (timer) clearTimeout(timer);
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [opened, url, logo]);

  const handleDownloadClick = async () => {
    const blobUrl = logo ? await fetchImageAsBlobUrl(logo) : null;
    const qrCodeDownload = createQrCode(1000, url, blobUrl);
    qrCodeDownload.download({
      name: title + " QR Code",
      extension: "png",
    });
    // Optional timeout to allow download process
    setTimeout(() => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    }, 1000);
  };

  const handlePrintClick = async () => {
    const blobUrl = logo ? await fetchImageAsBlobUrl(logo) : null;
    const qrCodePrint = createQrCode(2000, url, blobUrl);
    printQR(qrCodePrint, title + " QR Code");
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={
        <Group gap="xs">
          <IconQrcode size={22} />
          {/* title */}
          <Text fw={600}>{title} QR Code</Text>
        </Group>
      }
      centered
      radius="lg"
      size="sm"
    >
      <Stack align="center" gap="lg" py="md">
        <Paper
          withBorder
          p="lg"
          radius="lg"
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
          }}
        >
          <Box ref={qrModalRef} />
        </Paper>

        <Text size="sm" c="dimmed" ta="center">
          {/* description */}
          {description}
        </Text>

        <Group gap="sm">
          <Button
            variant="light"
            color="teal"
            leftSection={<IconPrinter size={18} />}
            onClick={handlePrintClick}
            radius="md"
          >
            Print
          </Button>
          <Button
            variant="light"
            color="teal"
            leftSection={<IconDownload size={18} />}
            onClick={handleDownloadClick}
            radius="md"
          >
            Download
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default QRCodeModal;
